export const CY: Record<string, string> = {
  "Recommended for you": "Argymhellir i chi",
  "Resource added to favorite": "Adnodd wedi'i ychwanegu at ffefrynnau",
  "Failed to add resource to favorite": "Methwyd ychwanegu adnodd at ffefrynnau",
  "Resource removed from favorite": "Adnodd wedi'i dynnu o ffefrynnau",
  "Failed to remove resource from favorite": "Methwyd tynnu adnodd o ffefrynnau",
  "Calendar": "Calendr",
  "View Detail": "Gweld manylion",
  "Add to favorites": "Ychwanegu at ffefrynnau",
  "Remove from favorites": "Dynnu o ffefrynnau",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Disgrifiad: Ystafell gyfarfod VIP gyda golygfa wych a chadeiriau cyfforddus.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Nid oes adnoddau ar gael ar yr amser a ddewiswyd yn eich lleoliad neu yn eich ffefrynnau.",
  "You have these options:": "Mae gennych yr opsiynau hyn:",
  "Change the meeting time.": "Newid amser y cyfarfod.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Defnyddiwch y botwm <1>Dod o hyd i Amser Sydd ar Gael</1> i ddewis amser newydd.",
  "Open the search to find other resources.": "Agorwch y chwiliad i ddod o hyd i adnoddau eraill.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Nid oes adnodd <1>'{{resourceType}}'</1> ar gael ar eich lleoliad rhagosodedig",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Gall adnodd <1>'{{resourceType}}'</1> fod ar lleoliad gwahanol.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Cliciwch yma</1> i ychwanegu'r math o adnodd i'ch gosodiadau lleoliad rhagosodedig.",
  
  // ResourceCard
  "New Order": "Archeb newydd",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Pan mae archebu Pooled Resource, gallwch archebu dim ond y math o adnodd hwn a dim ond un.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Ni allwch ddewis un adnodd a'i fodl-adnodd ar y un yn unig.",
  // Settings
  "Note:": "Nodyn:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Gall Trefnydd Cynorthwyol dderbyn yr un e-byst o Resource Central â'r trefnydd a gall drin archebion ar ran y trefnydd.",
  "Setting updated successfully": "Gosodiad wedi'i ddiweddaru'n llwyddiannus",
  "Setting updated failed": "Methwyd diweddaru gosodiad",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 lle",
  "Opening hours:": "Oriau agor:",
  "Buffer time {{minutes}} mins between reservations": "Amser byffer {{minutes}} mun rhwng archebion",
  "Initial payment {{value}} pr.minute": "Taliad cychwynnol {{value}} y funud",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Cyfanswm {{total}} o fynychwyr",
  "{{internal}} of {{total}} internal can attend.": "Gall {{internal}} o {{total}} mewnol fynychu.",
  "{{external}} external is unknown.": "Mae {{external}} allanol yn anhysbys.",
  "Find available time": "Dod o hyd i amser sydd ar gael",
  "Attendees": "Mynychwyr",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Cliciwch ar Rhagor o wybodaeth i ymweld â'n gwefan gymorth",
  "Further information": "Rhagor o wybodaeth",
  
  // LocationSetting
  "Location changed": "Lleoliad wedi'i newid",
  "Location change failed": "Methwyd newid lleoliad",
  "Please select at least one location": "Dewiswch o leiaf un lleoliad",
  "Resource types": "Mathau o adnoddau",
  "Location": "Lleoliad",
  "Where": "Ble",
  
  // ModalShowAttendees
  "Total": "Cyfanswm",
  "Available": "Ar gael",
  "Busy": "Prysur",
  "External": "Allanol",
  "Internal": "Mewnol",
  
  // ResourceSearch
  "Search by resource name": "Chwilio yn ôl enw adnodd",
  "Category": "Categori",
  "Filter by Location": "Hidlo yn ôl lleoliad",
  "Filter by Category": "Hidlo yn ôl categori",
  "Capacity": "Cynhwysedd",
  "Filter by Capacity": "Hidlo yn ôl cynhwysedd",
  "All": "Pob un",
  "Filter by availability": "Hidlo yn ôl argaeledd",
  "Sort By": "Trefnu yn ôl",
  "Loading...": "Yn llwytho...",
  
  // SelectedResources
  "Meeting Type": "Math o gyfarfod",
  "Meeting Label": "Label cyfarfod",
  
  // Alert (accessibility text)
  "Check icon": "Eicon gwirio",
  "Close": "Cau",
  
  // AppConstants - searchTab
  "Resource": "Adnodd",
  "Person": "Person",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Ble mae eich cyfarfodydd yn digwydd fel arfer?",
  "To improve our recommendations for you we would like you to enter your normal location": "I wella ein hargymhellion i chi, hoffem i chi nodi eich lleoliad arferol",
  "What do you use most?": "Beth ydych chi'n ei ddefnyddio fwyaf?",
  "To enable quicker and better search please chose you prefered resource type": "I alluogi chwilio cyflymach a gwell, dewiswch eich math o adnodd a ffefrir",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Cliciwch ar adnodd i ddewis",
  "Selected Resources": "Adnoddau a ddewiswyd",
  "Setting": "Gosodiad",
  "Search": "Chwilio",
  "Find Colleague": "Dod o hyd i gydweithiwr",
  "Quick button setting": "Gosodiad botwm cyflym",
  "Favorite": "Ffefryn",
  "Most Used": "Y mwyaf a ddefnyddir",
  "Colleagues": "Cydweithwyr",
  "Resources": "Adnoddau",
  
  // AppConstants - tooltipText
  "Back": "Yn ôl",
  "Floor Plan": "Cynllun llawr",
  "Expand": "Ehangu",
  "Selected resources": "Adnoddau a ddewiswyd",
  "View details": "Gweld manylion",
  "Remove from My Favorites": "Tynnu o'm ffefrynnau",
  "Add to My Favorites": "Ychwanegu at fy ffefrynnau",
  "Remove": "Tynnu",
  "Favorite - Most Used": "Ffefryn - Y mwyaf a ddefnyddir",
  "Conflict": "Gwrthdaro",
  "Approved": "Cymeradwy",
  "Recommendeded for you": "Argymhellir i chi",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Trefnydd cynradd yn unig",
  "Only assistant organizer": "Trefnydd cynorthwyol yn unig",
  "Primary AND assistant organizer": "Trefnydd cynradd A chynorthwyol",
  
  // FindColleague
  "Enter colleague name": "Rhowch enw cydweithiwr",
  "Recent work items": "Eitemau gwaith diweddar",
  "No data available": "Dim data ar gael",
  "Floorplan": "Cynllun llawr",
  "List nearby resources": "Rhestr o adnoddau gerllaw",
  "Find resource nearby": "Dod o hyd i adnodd gerllaw",
  "No Resources available": "Dim adnoddau ar gael",
  
  // Start page
  "Next": "Nesaf",
  "Failed to update default locations": "Methwyd diweddaru lleoliadau rhagosodedig",
  "Resource Type": "Math o adnodd",
  
  // QuickSetting
  "Quick buttons updated successfully": "Botymau cyflym wedi'u diweddaru'n llwyddiannus",
  "Quick buttons updated failed": "Methwyd diweddaru botymau cyflym",
  "Add more": "Ychwanegu mwy",
  "Apply": "Cymhwyso",
  "Delete": "Dileu",
  "Name": "Enw",
  "Enter name": "Rhowch enw",
  "Tooltip": "Awgrym offer",
  "Enter tooltip": "Rhowch awgrym offer",
  "Type": "Math",
  "Select type": "Dewiswch fath",
  "Locations": "Lleoliadau",
  "Select colleagues": "Dewis cydweithwyr",
  "Select resources": "Dewis adnoddau",
  
  // DefaultResourceSetting
  "Resource type changed": "Math o adnodd wedi newid",
  "Resource type change failed": "Methwyd newid math o adnodd",
  "Default Resource Type": "Math o adnodd rhagosodedig",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Wedi'i gymhwyso'n llwyddiannus",
  "Apply Failed": "Methwyd cymhwyso",
  "Assistant Organizer": "Trefnydd cynorthwyol",
  "Enter a part of the name to search for": "Rhowch ran o'r enw i chwilio amdano",
  "Mail Flow": "Llif e-bost",
  "Select Mail Flow": "Dewis llif e-bost",
  
  // TileConfigurationSetting
  "Update settings successfully": "Gosodiadau wedi'u diweddaru'n llwyddiannus",
  "Update settings failed": "Methwyd diweddaru gosodiadau",
  "Timeline": "Llinell amser",
  
  // SelectCategoryForm
  "And": "A",
  "Or": "Neu",
  
  // Other
  "Resource Calendar": "Calendr adnoddau",
  
  // SettingLabels
  "Default Location": "Lleoliad rhagosodedig",
  "Quick button": "Botwm cyflym",
  "Category icons": "Eiconau categori",
  "Recommendation screen": "Sgrin argymhelliadau",
  "Capacity filter": "Hidlydd capasiti",
  "AI Assistant": "Cynorthwyydd AI",
  "Tile configuration": "Cyfluniad teils",
  "Help": "Cymorth",
  "Default Categories": "Categoriadau rhagosodedig",
  
  // MeetingType
  "Your must select a Meeting label": "Rhaid i chi ddewis label cyfarfod",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Adnodd a ddewiswyd: 'AOD_Copanhagen' Digwyddiadau gwrthdaro",
  "Alternative Resource": "Adnodd amgen",
  "OK": "Iawn",
  "Cancel": "Canslo",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Cafodd eich adnodd a ddewiswyd 'AOD_Copenhagen' ei dynnu",
  "You can't book this resource as your request exceeds the available capacity.": "Ni allwch archebu'r adnodd hwn gan fod eich cais yn fwy na'r capasiti sydd ar gael.",
  
  // ChangeTime
  "Time changed successfully": "Amser wedi'i newid yn llwyddiannus",
  "Current Time": "Amser cyfredol",
  "Suggested Times": "Amseroedd a awgrymir",
  "Change Time": "Newid amser",
  "people are free": "bobl yn rhydd",
};

